export default {
    search: '搜索',
    cancel: '取消',
    reset: '重置',
    OK: '确定',
    noSearchResult: '未搜索到结果',
    empty: '还没有内容呢~',
    workflow: '个流程',
};
